module.exports = __webpack_public_path__ + "img/logo.110d3e20.svg";